import { useSelector } from "react-redux";
import SchoolAdminDashboard from "../../schoolAdminDashboard";
import HoursGraphChart from "./HoursGraphChart";

const HoursGraphContainer = () => {
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  return (
    <>
      <SchoolAdminDashboard />
      <div
        className={
          isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
        }
      >
        <div className="mng-header stickyy">
          <h4 className="fs-24 bold mob-hd">Hours Graph Chart</h4>
        </div>
        <div className="pd-20">
          <HoursGraphChart />
        </div>
      </div>
    </>
  );
};

export default HoursGraphContainer;
